import { FC } from 'react';
import React from 'react';
import { Item } from './Item';
import { CartItem } from '@/page/shoppingCar/views/api';
import { FlatList } from 'react-native';
import { KText, KView } from '@/component/RtlLayout';
import empty from '@/assets/images/empty.png';
import { $k18n } from '@/common/i18n';
import { LogShow } from '@/component/ViewVisible/ViewVisible';
import { styles } from '@/common/style';
import Image from '@kds/image';

interface IProps {
    model: any;
    setParams: {
        setCurItemId: Function;
        setCurItem: Function;
        setShowPop: Function;
    };
    height: null | number | string;
    init?: boolean;
}

export const ItemList: FC<IProps> = (props: React.PropsWithChildren<IProps>) => {
    const { model, setParams, height, init } = props;

    if (!init) {
        return (
            <KView style={{ height, alignItems: 'center', justifyContent: 'center' }}>
                <Image
                    style={styles({
                        width: 50,
                        height: 50,
                    })}
                    source={{ uri: 'https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/img/loading-normal.gif' }}
                />
            </KView>
        );
    }

    return model.state.items.length ? (
        <FlatList
            // 最后Push一个item，展示底部的KwaiShop入口
            data={model.state.items as CartItem[]}
            style={{
                height,
            }}
            renderItem={({ item }) => {
                return (
                    <LogShow
                        action="VIDEO_ADD_ON_POPUP"
                        params={{
                            item_id: item.commodityId,
                        }}
                    >
                        <Item
                            item={item}
                            setParams={setParams}
                            showCartProp={true}
                            shopInfoProp={model.state.shopInfo}
                            model={model}
                            aniItemRef={0}
                            onCountDownFinish={() => undefined}
                        />
                    </LogShow>
                );
            }}
        />
    ) : (
        <KView
            style={{
                height: '80%',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Image source={empty} style={{ width: 96, height: 96 }} />
            <KText>{$k18n({ id: 'k_252269', text: '暂无商品' })}</KText>
        </KView>
    );
};
